import React, { use, useCallback, useEffect, useRef, useState } from "react";
import {
  featuredJobs,
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  TextField,
  CircularProgress,
  Avatar,
  useMediaQuery,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useLocation, useNavigate } from "react-router-dom";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import {
  _get_job_feed_list_blog_api,
  _get_job_feed_list_blog_api_without_filters,
  delete_live_job_feed_api,
  favourite_live_job_api,
} from "../../DAL/partner/partners";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import moment from "moment";
import { s3baseUri } from "../../config/config";
import SkeletonJObs from "../../components/loader/jbsSkeleton";
import CustomDrawer from "../../components/layouts/CustomDrawer";
import JobsFilter from "./JobsFilter";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function PersonalJobs() {
  const navigate = useNavigate();
  const { findId, setBreadCrumb, isRefresh } = useIds();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery("(max-width:600px)");

  const [openDetail, setOpenDetail] = useState(false);
  const [cv, setCv] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const { pathname } = useLocation();
  const [partnersObj, setPartnersObj] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const load_more_path = "api/jobs/personal_list?page=0&limit=15";
  console.log(findId, "findIdfindId");
  console.log(partnersObj, "partnersObjpartnersObjpartnersObj");
  let icon = {
    iconBg: "#000080",
  };

  const handleOpenDetail = (job) => {
    navigate(
      `/${firstSegment}/live-job-feed/personal-jobs/job-detail/${job._id}`,
      {
        state: { job },
        topic: featuredJobs,
      }
    );
  };
  const fetchCategories = async (path, search, loading, id) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }

    if (!id) {
      id = findId || localStorage.getItem("source_id");
      console.log(id, "ididididid");
    }
    const response = await _get_job_feed_list_blog_api_without_filters(
      id,
      search,
      path
    );
    console.log(path, "responserespopathpathpathpathnseresponse");
    console.log(response.load_more_url, "");
    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);
      if (loading) {
        let new_array = categories.concat(response.jobs);
        setCategories(new_array);

        console.log(new_array, "new_arraynew_array");
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        console.log(response.jobs, "response.jobs");
        setPageNumber(1);
      }
      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      // enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    fetchCategories(loadMorePath, searchTerm, true, findId);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );
  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchTerm, false, findId);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm]);

  useEffect(() => {
    fetchCategories(load_more_path, searchTerm, false, findId);
  }, [isRefresh]);
  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: `/${firstSegment}/live-job-feed`,
        active: false,
      },
      {
        name: `My Job Posts`,
        path: ``,
        active: true,
      },
    ]);
  }, []);

  // Filter state
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    experience: "",
    jobType: "",
    frequency: "",
    salary: "",
    education_required: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    experience: null,
    jobType: null,
    frequency: null,
    salary: null,
    education_required: null,
  });

  // Filter handlers
  const handleFilterChange = (e) => {
    setFilterValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleFilterDrawerOpen = () => setFilterDrawerOpen(true);
  const handleFilterDrawerClose = () => setFilterDrawerOpen(false);
  const handleFilterClear = () => {
    setFilterValues({
      experience: "",
      jobType: "",
      frequency: "",
      salary: "",
      education_required: "",
    });
    setAppliedFilters({
      experience: null,
      jobType: null,
      frequency: null,
      salary: null,
      education_required: null,
    });
    setFilterDrawerOpen(false);
  };
  const handleRemoveFilterChip = (key) => {
    setFilterValues((prev) => ({ ...prev, [key]: "" }));
    setAppliedFilters((prev) => ({ ...prev, [key]: null }));
  };
  const applyFilters = (e) => {
    if (e) e.preventDefault();

    const filters = {
      experienceRequired: filterValues.experience,
      jobType: filterValues.jobType,
      frequencySalary: filterValues.frequency,
      salary: filterValues.salary,
      educationRequired: filterValues.education_required,
    };

    setFilterDrawerOpen(false);

    setAppliedFilters({
      experience: filterValues.experience || null,
      jobType: filterValues.jobType || null,
      frequency: filterValues.frequency || null,
      salary: filterValues.salary || null,
      education_required: filterValues.education_required || null,
    });
  };
  const filterLabels = {
    experience: "Experience",
    jobType: "Job Type",
    frequency: "Frequency",
    salary: "Salary",
    education_required: "Education",
  };
  const getFilterValueDisplay = (key, value) => {
    if (key === "experience") return show_des_data(value);
    if (key === "education_required") return formatEducationRequired(value);
    return value;
  };

  // Filter categories client-side
  const filteredCategories = categories.filter((job) => {
    if (
      appliedFilters.experience &&
      job.experienceRequired !== appliedFilters.experience
    )
      return false;
    if (appliedFilters.jobType && job.jobType !== appliedFilters.jobType)
      return false;
    if (
      appliedFilters.frequency &&
      job.frequencySalary !== appliedFilters.frequency
    )
      return false;
    if (
      appliedFilters.salary &&
      String(job.salary) !== String(appliedFilters.salary)
    )
      return false;
    if (
      appliedFilters.education_required &&
      job.educationRequired !== appliedFilters.education_required
    )
      return false;

    return true;
  });

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick(row) {
        handleOpenEditJob(row);
      },
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
    },
  ];

  // useEffect(() => {
  //   if (!loading) {
  //     const timeoutId = setTimeout(() => {
  //       fetchCategories(loadMorePath, searchText);
  //     }, 800);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [searchText]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTerm(searchInputValue);
    }, 1000);
    return () => clearTimeout(handler);
  }, [searchInputValue]);

  let login_nfo = localStorage.getItem("user");

  let user_info = login_nfo ? JSON.parse(login_nfo) : null; // Safely parse JSON if data exists
  console.log(user_info, "Parsed user_info");

  const handleCloseDetail = () => {
    setOpenDetail(false);
    setCv(null);
  };

  // const handleOpenDetail = (job) => {
  //   setSelectedJob(job);
  //   setOpenDetail(true);
  // };

  let arr = [12, 34, 67, 12, 88, 9, 0];
  let max = arr[0];
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      max = arr[i];
    }
  }

  console.log("Largest number:", max);

  const handleBookmarkToggle = (jobId) => {
    console.log(jobId, "jobIdjobIdjobIdjobId");

    const newBookmarkedState = !bookmarkedJobs[jobId]; // Toggle state optimistically

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };
  const handleCandidiates = (job) => {
    navigate(
      `/${firstSegment}/live-job-feed/personal-jobs/job-candidates-page/${job._id}`,
      {
        state: { job },
        topic: featuredJobs,
      }
    );
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handlePersonalJob = (job) => {
    console.log("callled");
    navigate(`/${firstSegment}/live-job-feed/personal-jobs`);
  };

  const handleClose = () => {
    setEditMode(false);
    setSelectedJob(null);

    setOpen(false);
  };
  const handleOpenEditJob = (job) => {
    setEditMode(true);
    setSelectedJob(job);
    setOpen(true);
  };
  const formatSalaryFrequency = (frequency) => {
    switch (frequency) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };

  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setLoading(true);
    console.log("Deleting Member ID:", id); // Debugging ke liye

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };

  const handleDelete = (row) => {
    console.log(row._id, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };

  return (
    <>
      <PostJobModal
        refreshlist={fetchCategories}
        loadMorePath={load_more_path}
        searchTerm={searchTerm}
        loadingstate={loading}
        id={findId}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        jobData={selectedJob} // Pass selected job data when editing
        sourceId={sourceId}
      />

      <PostJobDetail
        cv={cv}
        open={openDetail}
        setCv={setCv}
        job={selectedJob}
        handleClose={handleCloseDetail}
      />
      {isMobile ? (
        <div className="container-fluid">
          <div className="row">
            <div className="mt-3 mb-4">
              <div className="card-body mt-1 main-heading-live-jobs jobs-live-main">
                <div className="d-flex flex-column flex-md-row justify-content-between mb-3">
                  <h2 className="ml-2">My Job Posts</h2>
                  <div className="d-flex flex-column flex-sm-row gap-2 w-90 w-md-auto">
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      placeholder="Search by Job Title, Description"
                      value={searchInputValue}
                      onChange={handleInputChange}
                      sx={{ minWidth: 320, flexGrow: 1 }}
                      InputProps={{
                        sx: {
                          "& input::placeholder": {
                            color: "#b0b0b0",
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    {/* <button
                      className="small-button-contain-job-live"
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                      onClick={handleFilterDrawerOpen}
                      type="button"
                    >
                      <FilterListIcon
                        style={{ fontSize: 20, marginRight: 4 }}
                      />
                      Filter
                    </button> */}
                  </div>
                </div>
                {/* Filter Chips Section (Mobile) */}
                <Box mb={2} display="flex" flexWrap="wrap" gap={1}>
                  {Object.values(appliedFilters).some(Boolean) && (
                    <Chip
                      label="Clear All"
                      onDelete={handleFilterClear}
                      color="error"
                      sx={{
                        background: "#ffeaea",
                        color: "#d32f2f",
                        fontWeight: 600,
                      }}
                    />
                  )}
                  {Object.entries(appliedFilters)
                    .filter(([key, value]) => value)
                    .map(([key, value]) => (
                      <Chip
                        key={key}
                        label={`${
                          filterLabels[key] || key
                        }: ${getFilterValueDisplay(key, value)}`}
                        onDelete={() => handleRemoveFilterChip(key)}
                        sx={{ background: "#f0f0f0" }}
                      />
                    ))}
                </Box>
                {loading ? (
                  <SkeletonJObs />
                ) : (
                  <Box className="row" mt={2}>
                    {categories.length > 0 ? (
                      categories.map((job, index) => (
                        <div key={index} className="col-12 mb-3">
                          <Card
                            onClick={() => handleOpenDetail(job)}
                            variant="outlined"
                            className="mui-card"
                            sx={{
                              borderRadius: 2,
                              mb: 2,
                              p: 2,
                              border: "2px solid transparent !important", // Normal state: no visible border
                              transition: "all 0.3s ease",
                              "&:hover": {
                                border: "2px solid #DAA520 !important",
                              },
                              position: "relative",
                              cursor: "pointer",
                            }}
                          >
                            {job.status === false && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  backgroundColor: "#d32f2f",
                                  color: "white",
                                  padding: "2px 5px",
                                  fontWeight: "bold",
                                  borderRadius: "0 0 10px 0",
                                  zIndex: 1,
                                  fontSize: "12px",
                                }}
                              >
                                Inactive
                              </Box>
                            )}

                            <CardContent className="card-content-mui">
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box
                                    onClick={() => handleOpenDetail(job)}
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <Avatar
                                      src={
                                        s3baseUri +
                                        job?.creater_info?.profile_image
                                      }
                                      alt=""
                                      style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Box>
                                  <Box>
                                    <Typography
                                      onClick={() => handleOpenDetail(job)}
                                      variant="h6"
                                      className="ms-3"
                                      fontWeight="bold"
                                      sx={{ cursor: "pointer" }}
                                    >
                                      {job.jobTitle}
                                    </Typography>
                                    <Typography
                                      onClick={() => handleOpenDetail(job)}
                                      variant="body2"
                                      className="ms-3"
                                      color="textSecondary"
                                      sx={{ cursor: "pointer" }}
                                    >
                                      {job.location} •{" "}
                                      <span
                                        style={{
                                          color: "navy",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment(job.createdAt).fromNow()}
                                      </span>
                                    </Typography>
                                  </Box>
                                </Box>
                                <div className="d-flex align-items-center">
                                  {user_info?.type === 1 && (
                                    <IconButton
                                      onClick={() =>
                                        handleBookmarkToggle(job._id)
                                      }
                                      sx={{
                                        paddingRight: "3px !important",
                                        paddingTop: "2px !important",
                                        paddingBottom: "0px !important",
                                      }}
                                    >
                                      {bookmarkedJobs[job._id] ? (
                                        <BookmarkIcon
                                          sx={{
                                            color: "#000080",
                                            padding: "0px !important",
                                          }}
                                        />
                                      ) : (
                                        <BookmarkBorderIcon
                                          sx={{
                                            padding: "0px !important",
                                          }}
                                        />
                                      )}
                                    </IconButton>
                                  )}

                                  <CustomPopoverSection
                                    menu={MENU_OPTIONS}
                                    data={job}
                                  />
                                </div>
                              </Box>

                              <Box
                                display="flex"
                                flexWrap="wrap"
                                gap={1}
                                my={2}
                                onClick={() => handleOpenDetail(job)}
                              >
                                <Chip
                                  className="mui-chip"
                                  label={job.jobType}
                                  variant="outlined"
                                />
                                <Chip
                                  className="mui-chip"
                                  label={show_des_data(job?.experienceRequired)}
                                  variant="outlined"
                                />
                                <Chip
                                  className="mui-chip"
                                  label={formatEducationRequired(
                                    job?.educationRequired
                                  )}
                                  variant="outlined"
                                />
                              </Box>

                              <Typography
                                variant="body1"
                                sx={{
                                  mt: 2,
                                  fontSize: "15px",
                                  cursor: "pointer",
                                  display: "inline",
                                  mb: 0,
                                }}
                                onClick={() => handleOpenDetail(job)}
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      job.description.length > 300
                                        ? `${job.description.slice(0, 300)}...`
                                        : job.description,
                                  }}
                                />
                                {job.description.length > 300 && (
                                  <span
                                    style={{
                                      color: "navy",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => handleOpenDetail(job)}
                                  >
                                    Read More
                                  </span>
                                )}
                              </Typography>

                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                flexDirection={{ xs: "column", sm: "row" }}
                                gap={2}
                                mt={2}
                              >
                                <Box display="flex" flexDirection="row" gap={1}>
                                  {job?.minSalary && job?.maxSalary ? (
                                    <>
                                      <Chip
                                        variant="outlined"
                                        className="mui-chip"
                                        label={`Min Salary: €${
                                          job.minSalary
                                        }/${formatSalaryFrequency(
                                          job?.frequencySalary
                                        )}`}
                                        onClick={() => handleOpenDetail(job)}
                                        sx={{ cursor: "pointer" }}
                                      />
                                      <Chip
                                        className="mui-chip"
                                        variant="outlined"
                                        label={`Max Salary: €${
                                          job.maxSalary
                                        }/${formatSalaryFrequency(
                                          job?.frequencySalary
                                        )}`}
                                        onClick={() => handleOpenDetail(job)}
                                      />
                                    </>
                                  ) : (
                                    <Chip
                                      className="mui-chip"
                                      variant="outlined"
                                      label={`Fixed Salary: €${
                                        job?.salary || "N/A"
                                      }/${formatSalaryFrequency(
                                        job?.frequencySalary
                                      )}`}
                                      onClick={() => handleOpenDetail(job)}
                                      sx={{ cursor: "pointer" }}
                                    />
                                  )}
                                </Box>

                                <Box display="flex" flexWrap="wrap" gap={1}>
                                  {job.created_by ===
                                    user_info?.user_id?._id && (
                                    <div className="position-relative">
                                      <div
                                        className="badge position-absolute"
                                        style={{
                                          top: "-7px",
                                          right: "-6px",
                                          backgroundColor: "#FF0000",
                                          color: "#fff",
                                          padding: "2px 6px",
                                          borderRadius: "12px",
                                          minWidth: "20px",
                                          textAlign: "center",
                                          fontSize: "12px",
                                          lineHeight: "1.2",
                                        }}
                                      >
                                        {job?.job_applicants?.length || 0}
                                      </div>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                          handleCandidiates(job);
                                        }}
                                        className="small-button-contain-job-candidates"
                                        style={{
                                          whiteSpace: "nowrap",
                                          padding: "6px 12px",
                                          fontSize: "0.875rem",
                                        }}
                                      >
                                        View Candidates
                                      </button>
                                    </div>
                                  )}
                                  <button
                                    onClick={() => handleOpenDetail(job)}
                                    className="small-button-contain-job-candidates"
                                    style={{
                                      whiteSpace: "nowrap",
                                      padding: "6px 12px",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    View Details
                                  </button>
                                </Box>
                              </Box>
                            </CardContent>
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div>
                        <RecordNotFound title="No jobs" />
                      </div>
                    )}
                    {totalPages >= pageNumber && (
                      <div className="col-12 text-center mt-3">
                        <span
                          ref={lastBookElementRef}
                          className="mt-3"
                          onClick={loadMoreData}
                          id="load-more-feed"
                        >
                          {isLoadingMore ? (
                            <CircularProgress color="primary" size="1.5rem" />
                          ) : (
                            "Load More"
                          )}
                        </span>
                      </div>
                    )}
                  </Box>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="mt-3 mb-4">
              <div className="card-body mt-1 main-heading-live-jobs jobs-live-main">
                <div className="d-flex justify-content-between mb-3">
                  <h2 className="ml-4">My Job Posts</h2>
                  <div className="d-flex gap-2">
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      placeholder="Search by Job Title, Description"
                      value={searchInputValue}
                      onChange={handleInputChange}
                      sx={{ minWidth: 320, flexGrow: 1 }}
                      InputProps={{
                        sx: {
                          "& input::placeholder": {
                            color: "#b0b0b0",
                            opacity: 1,
                          },
                        },
                      }}
                    />
                    {/* <button
                      className="small-button-contain-job-live"
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                      onClick={handleFilterDrawerOpen}
                      type="button"
                    >
                      <FilterListIcon
                        style={{ fontSize: 20, marginRight: 4 }}
                      />
                      Filter
                    </button> */}
                  </div>
                </div>
                {/* Filter Chips Section (Desktop) */}
                <Box mb={2} display="flex" flexWrap="wrap" gap={1}>
                  {Object.values(appliedFilters).some(Boolean) && (
                    <Chip
                      label="Clear All"
                      onDelete={handleFilterClear}
                      color="error"
                      sx={{
                        background: "#ffeaea",
                        color: "#d32f2f",
                        fontWeight: 600,
                      }}
                    />
                  )}
                  {Object.entries(appliedFilters)
                    .filter(([key, value]) => value)
                    .map(([key, value]) => (
                      <Chip
                        key={key}
                        label={`${
                          filterLabels[key] || key
                        }: ${getFilterValueDisplay(key, value)}`}
                        onDelete={() => handleRemoveFilterChip(key)}
                        sx={{ background: "#c0cdfa", color: "#000" }}
                      />
                    ))}
                </Box>
                {loading ? (
                  <SkeletonJObs />
                ) : (
                  <Box className="row" mt={2}>
                    {filteredCategories.length > 0 ? (
                      filteredCategories.map((job, index) => (
                        <div key={index} className="col-12 mb-3">
                          {" "}
                          {/* Full width card */}
                          <Card
                            onClick={() => handleOpenDetail(job)}
                            variant="outlined"
                            className="mui-card"
                            sx={{
                              borderRadius: 2,
                              mb: 2,
                              p: 2,
                              border: "2px solid transparent !important", // Normal state: no visible border
                              transition: "all 0.3s ease",
                              "&:hover": {
                                border: "2px solid #DAA520 !important",
                              },

                              position: "relative", // Added for positioning the badge
                              cursor: "pointer",
                            }}
                          >
                            {/* Inactive Badge */}
                            {job.status === false && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  backgroundColor: "#d32f2f",
                                  color: "white",
                                  padding: "2px 5px",
                                  fontWeight: "bold",
                                  borderRadius: "0 0 10px 0", // Rounded corner on the right side
                                  zIndex: 1, // Ensures it stays above other content
                                  fontSize: "12px",
                                }}
                              >
                                Inactive
                              </Box>
                            )}

                            <CardContent className="card-content-mui">
                              {/* Header */}
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box
                                    onClick={() => handleOpenDetail(job)}
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <Avatar
                                      src={
                                        s3baseUri +
                                        job?.creater_info?.profile_image
                                      }
                                      alt=""
                                      style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Box>
                                  <Box>
                                    <Typography
                                      onClick={() => handleOpenDetail(job)}
                                      variant="h6"
                                      className="ms-3"
                                      fontWeight="bold"
                                      sx={{ cursor: "pointer" }}
                                    >
                                      {job.jobTitle}
                                    </Typography>
                                    <Typography
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => handleOpenDetail(job)}
                                      variant="body2"
                                      className="ms-3"
                                      color="textSecondary"
                                    >
                                      {job.location} •{" "}
                                      <span
                                        style={{
                                          color: "navy",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment(job.createdAt).fromNow()}
                                      </span>{" "}
                                    </Typography>
                                  </Box>
                                </Box>
                                <div className="d-flex">
                                  {user_info?.type === 1 && (
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                        handleBookmarkToggle(job._id);
                                      }}
                                      sx={{
                                        paddingRight: "3px !important",
                                        paddingTop: "2px !important",
                                        paddingBottom: "0px !important",
                                      }}
                                    >
                                      {bookmarkedJobs[job._id] ? (
                                        <BookmarkIcon
                                          sx={{
                                            color: "#000080",
                                            padding: "0px !important",
                                          }}
                                        />
                                      ) : (
                                        <BookmarkBorderIcon
                                          sx={{
                                            padding: "0px !important",
                                          }}
                                        />
                                      )}
                                    </IconButton>
                                  )}
                                  <div onClick={(e) => e.stopPropagation()}>
                                    {" "}
                                    {/* ⚠️ Prevent Card's onClick */}
                                    <CustomPopoverSection
                                      menu={MENU_OPTIONS}
                                      data={job}
                                    />
                                  </div>
                                </div>
                              </Box>

                              {/* Job Tags */}
                              <Box
                                display="flex"
                                gap={1}
                                my={2}
                                onClick={() => handleOpenDetail(job)}
                              >
                                <Chip
                                  className="mui-chip"
                                  label={job.jobType}
                                  variant="outlined"
                                />
                                <Chip
                                  className="mui-chip"
                                  label={show_des_data(job?.experienceRequired)}
                                  variant="outlined"
                                />
                                <Chip
                                  className="mui-chip"
                                  label={formatEducationRequired(
                                    job?.educationRequired
                                  )}
                                  variant="outlined"
                                />
                              </Box>

                              <Typography
                                variant="body1"
                                sx={{
                                  mt: 2,
                                  fontSize: "15px",
                                  cursor: "pointer",
                                  display: "inline",
                                  mb: 0,
                                }}
                                onClick={() => handleOpenDetail(job)}
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      job.description.length > 300
                                        ? `${job.description.slice(0, 300)}...`
                                        : job.description,
                                  }}
                                />
                                {job.description.length > 300 && (
                                  <span
                                    style={{
                                      color: "navy",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => handleOpenDetail(job)}
                                  >
                                    Read More
                                  </span>
                                )}
                              </Typography>

                              {/* Salary & Apply */}
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={2}
                              >
                                <Box display="flex" flexDirection="row" gap={1}>
                                  {job?.minSalary && job?.maxSalary ? (
                                    <>
                                      <Chip
                                        variant="outlined"
                                        className="mui-chip"
                                        label={`Min Salary: €${
                                          job.minSalary
                                        }/${formatSalaryFrequency(
                                          job?.frequencySalary
                                        )}`}
                                        onClick={() => handleOpenDetail(job)}
                                        sx={{ cursor: "pointer" }}
                                      />
                                      <Chip
                                        className="mui-chip"
                                        variant="outlined"
                                        label={`Max Salary: €${
                                          job.maxSalary
                                        }/${formatSalaryFrequency(
                                          job?.frequencySalary
                                        )}`}
                                        onClick={() => handleOpenDetail(job)}
                                      />
                                    </>
                                  ) : (
                                    <Chip
                                      className="mui-chip"
                                      variant="outlined"
                                      label={`Fixed Salary: €${
                                        job?.salary || "N/A"
                                      }/${formatSalaryFrequency(
                                        job?.frequencySalary
                                      )}`}
                                      onClick={() => handleOpenDetail(job)}
                                      sx={{ cursor: "pointer" }}
                                    />
                                  )}
                                </Box>

                                <div className="d-flex">
                                  {job.created_by ===
                                    user_info?.user_id?._id && (
                                    <div className="position-relative">
                                      <div
                                        className="badge position-absolute"
                                        style={{
                                          top: "-7px",
                                          right: "2px",
                                          backgroundColor: "#FF0000",
                                          color: "#fff",
                                          padding: "2px 6px",
                                          borderRadius: "12px",
                                          minWidth: "20px",
                                          textAlign: "center",
                                          fontSize: "12px",
                                          lineHeight: "1.2",
                                        }}
                                      >
                                        {job?.job_applicants?.length || 0}
                                      </div>
                                      <button
                                        style={{ width: "auto !important" }}
                                        onClick={(e) => {
                                          e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                          handleCandidiates(job);
                                        }}
                                        className="small-button-contain-job-candidates me-2"
                                      >
                                        View Candidates{" "}
                                      </button>
                                    </div>
                                  )}
                                  <button
                                    onClick={() => handleOpenDetail(job)}
                                    className="small-button-contain-job"
                                  >
                                    View Details{" "}
                                  </button>
                                </div>
                              </Box>
                            </CardContent>
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div>
                        <RecordNotFound title="No jobs" />
                      </div>
                    )}
                    {totalPages >= pageNumber ? (
                      <div className="col-12 text-center mt-3">
                        <span
                          ref={lastBookElementRef}
                          className="mt-3"
                          onClick={loadMoreData}
                          id="load-more-feed"
                        >
                          {isLoadingMore ? (
                            <CircularProgress color="primary" size="1.5rem" />
                          ) : (
                            "Load More"
                          )}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </Box>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <CustomDrawer
        isOpenDrawer={filterDrawerOpen}
        onCloseDrawer={handleFilterDrawerClose}
        pageTitle="Filter Jobs"
        componentToPassDown={
          <JobsFilter
            onCloseDrawer={handleFilterDrawerClose}
            selectedObject={null}
            refreshList={null}
            memberList={categories}
            applyFilters={applyFilters}
            handleFilterChange={handleFilterChange}
            filterValues={filterValues}
            handleFilterClear={handleFilterClear}
          />
        }
      />

      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this job?"}
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />
    </>
  );
}
